export const GOOGLE_ANALYTICS_APP_ID = 'UA-121494463-1';
